import { logger } from "~/utils/logger";
export default defineNuxtRouteMiddleware(async (to) => {
  // Only run on client side
  if (process.server) return;

  const auth = useAuthStore();

  // Only protect routes that start with /dashboard or /booking
  if (!to.path.startsWith("/dashboard")) {
    return;
  }

  logger.log("🔒 User Routes Middleware:", {
    path: to.path,
    authenticated: !!auth.user,
    sessionRestored: auth.sessionRestored,
    role: auth.user?.role,
  });

  // If session hasn't been restored yet, wait for it
  if (!auth.sessionRestored) {
    logger.log("⏳ Session not restored yet, checking Kratos session...");
    await auth.checkKratosSession();
  }

  // Check if user is authenticated and verified
  if (!auth.user) {
    logger.log("❌ User Routes: Not authenticated, redirecting to login");
    return navigateTo("/login");
  }

  // /dashboard/* is only for USER role
  if (to.path.startsWith("/dashboard")) {
    if (auth.user.role !== "USER") {
      logger.log(
        "❌ Dashboard Routes: Only USER role allowed, redirecting based on role",
        auth.user.role,
      );
      if (auth.user.role === "ADMIN") {
        return navigateTo("/admin", { replace: true });
      }
      if (auth.user.role === "BOOKING_MANAGER") {
        return navigateTo("/booking-manager", { replace: true });
      }
      // Fallback — avoid redirecting to "/" which can cause infinite loops
      return abortNavigation();
    }
  }

  // /booking/* is accessible by all authenticated users (USER, BOOKING_MANAGER, ADMIN)
  logger.log("✅ User Routes: Access granted for", auth.user.email);
});
